import Layout from "@/components/feature/Layout";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import QuickAccess from "./components/QuickAccess";
import FeaturesSection from "./components/FeaturesSection";
import AnnouncementsSection from "./components/AnnouncementsSection";
import FAQSection from "./components/FAQSection";
import SafetySection from "./components/SafetySection";

export default function Home() {
  return (
    <Layout>
      <HeroSection />
      <StatsBar />
      <QuickAccess />
      <FeaturesSection />
      <AnnouncementsSection />
      <FAQSection />
      <SafetySection />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "爱情岛网址官方入口·最新访问地址",
            description: "找不到爱情岛网址？本页为你提供爱情岛网址最新官方入口、备用访问地址及安全使用指南",
            url: "https://aiqingdao.com",
            isPartOf: {
              "@type": "WebSite",
              name: "爱情岛网址导航",
              url: "https://aiqingdao.com",
            },
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "首页",
                  item: "https://aiqingdao.com",
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "如何确认当前访问的是爱情岛官方网站？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "请通过本页面提供的官方入口链接访问。官方网址均采用HTTPS加密协议，浏览器地址栏会显示安全锁标识。",
                },
              },
              {
                "@type": "Question",
                name: "为什么爱情岛网址会经常变更？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "由于互联网环境的复杂性，部分网络服务商可能会对特定网站进行限制。为保障用户能够持续稳定地访问平台，爱情岛会不定期更新访问入口地址。",
                },
              },
              {
                "@type": "Question",
                name: "备用地址和官方入口有什么区别？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "官方入口是爱情岛的主访问地址，具有最高的稳定性和安全性。备用地址是在官方入口因网络原因暂时无法访问时提供的替代方案。",
                },
              },
            ],
          }),
        }}
      />
    </Layout>
  );
}